import React from "react";
import Helmet from "react-helmet";
import FormComprobante from "../../components/eld/FormComprobante";
import jsPDF from 'jspdf';
import domtoimage from 'dom-to-image';
import { Button } from "react-bootstrap";

export default function comprobante() {
    function printDocument() {

        const input = document.getElementById('pdfdiv');
        const pdf = new jsPDF();
        if (pdf) {
            domtoimage.toPng(input).then(imgData => {
                pdf.addImage(imgData, 'PNG', 10, 10);
                pdf.save('download.pdf');
            });
        }
    }
    return (
        <div className="container home">
            <Helmet>
                <title>Retiro Enfermos Terminales AFP Modelo | Solicitud de Retiro Enfermos Terminales | AFP Modelo</title>
                <meta name="description" content={``} />
                <meta name="robots" content="noindex, follow" />
            </Helmet>
            <div>
                <section>
                    <div className="w-100 container-padre calculadora">
                        <div className="row">
                            <div className="bloque form">
                                <div className="card formulario">
                                    <div id="pdfdiv" className="">
                                        <div className="card-title textoTitulo">
                                            Formulario Selección Modalidad con Excedente de Libre disposición (ELD)
                                        </div>
                                        <span className="text-green">
                                            ¡Tu selección ha sido ingresada!
                                        </span>
                                        <div className="card-body">
                                            <FormComprobante />
                                        </div>
                                    </div>
                                    <div className="comprobante-botones">
                                        <div className="col justify-content-center d-flex mb-2">
                                            <Button
                                                variant="success"
                                                className="col-md-12"
                                                type="submit"
                                                onClick={printDocument}
                                            >
                                                Descargar comprobante
                                            </Button>
                                        </div>
                                        <div className="justify-content-center d-flex mb-2">
                                            <Button variant="link" className="col-md-12"
                                                onClick={() => {
                                                    window.location.href = '/eld';
                                                }}>
                                                Volver al paso anterior
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    )
}